module.exports = __webpack_public_path__ + "img/guide.37a56335.jpg";